export function submitSiteAnchors() {
  const submitLink = $(".submit-site-sidebar").find("a");
  submitLink.on("click", function (event) {
    event.preventDefault();
    let $this = $(this);
    $(this).closest("li").addClass("current-menu-item").siblings().removeClass("current-menu-item");
    $("html, body").animate({
      scrollTop: $($this.attr("href")).offset().top - 150
    }, 700);
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/submitSiteAnchors.js